module.exports = __webpack_public_path__ + "static/media/smart-filter-bg-all-loads.30189588.svg";